import * as React from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';


const useStyles = makeStyles((theme) => ({
    calender: {
        "& div": {
            fontSize: "1.4rem !important",
            
        },
        "& span": {
            fontSize: "1.4rem !important",
           
        },
        "& button": {
            fontSize: "1.4rem !important",    
        },
        "& .MuiDialog-paper":{
            minWidth:"unset !important",
            width:"Fit-Content !important",
        },


        
    },
    datePicker: {
        "flex-direction": "row-reverse",
        fontSize: "1.4rem !important",
        "& fieldSet": {
            border: "none",
        },
        // marginTop: "0.6rem",
        width: "100% !important",
        background: "#F2F4F7",
        border: "1px solid #F2F4F7 !important",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgb(16 24 40 / 5%)",
        borderRadius: "0.8rem",
        justifyContent: 'flex-end',
        "& input": {
            width: "fit-content",
            fontSize: "1.4rem !important",
            padding: "1rem 1.4rem !important",
            color: "#667085"
        },
        "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #FFFFFF !important",
                boxShadow:
                    "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
            },
        },
        
        "&:hover": {
            // border:"none",
            "& .MuiOutlinedInput-notchedOutline": {
                // border: '1px solid #D0D5DD !important'
            },
        },
        "& button": {
            fontSize: "1.4rem"
        },
        
    },
    helperText: {
        fontSize: "1.4rem !important",
        margin: "0.2rem 0 0 0 !important",
        fontFamily: 'Inter-Medium !important',
        color: "#d32f2f !important"
    },
    label: {
        fontFamily: 'Inter-Regular',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '1.4rem',
        lineHeight: '2rem',
        color: '#344054',
        marginBottom: "0.6rem",
       
    },
}));

export default function MobileDateComponent({ helperText, onChangeDate,onCloseDate, value, label = '', disabled = false, minDate, maxDate, isMandatory = false }) {
    const classes = useStyles();

    return (
        <div className={classes.mainContainer}>
            {label !== '' &&
                <div className={classes.label}>
                    <p>{label} {isMandatory && <span style={{ color: "red" }}>*</span>}</p>
                </div>
            }
            <div className={classes.input}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                        disabled={disabled}
                        minDate={minDate ? minDate : new Date()}
                        maxDate={maxDate}
                        // minDateTime={minDate}
                        // maxDateTime={maxDate}
                        // minDateTime={new Date()}
                        value={value ? value : ''}
                        
                        onChange={(e) => e ? onChangeDate(e['$d']) : onChangeDate('')}
                        onClose={(e)=> e ? onCloseDate(e['$d']): onCloseDate('')}
                        PaperProps={{ className: classes.calender }}
                        DialogProps={{ className: classes.calender }}
                        PopperProps={{ placement: "bottom-start" }}
                        InputProps={{
                            className: classes.datePicker,
                            endAdornment: (
                                <InputAdornment position="start">
                                    <CalendarTodayOutlinedIcon
                                        style={{ fontSize: '2rem', marginLeft: '1.5rem', cursor: "pointer", color: "#667085" }}
                                    />
                                </InputAdornment>
                            )
                        }}
                        renderInput={(params) => (
                            <TextField
                                style={{ verticalAlign: "middle" }}
                                placeholder='MM-DD-YYYY'
                                {...params}
                                helperText={helperText}
                                FormHelperTextProps={{
                                    classes: {
                                        root: classes.helperText,
                                    },
                                }}
                                sx={[
                                    {
                                        "&>div:first-of-type": {
                                            border: helperText !== "" ? "1px solid red !important" : "1px solid #F2F4F7 !important",
                                            borderRadius: "0.8rem",
                                        },
                                        width: "100%",
                                    },
                                ]}
                            />
                        )}
                    />
                </LocalizationProvider>
            </div>
        </div>
    );
}
